import React, { CSSProperties } from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import { config as hLeftConfig } from '@framework/workbench/ui/align/align-horizontallt-left/config';
import { config as hCenterConfig } from '@framework/workbench/ui/align/align-horizontallt-center/config';
import { config as hRightConfig } from '@framework/workbench/ui/align/align-horizontallt-right/config';
import { config as vTopConfig } from '@framework/workbench/ui/align/align-vertically-top/config';
import { config as vCenterConfig } from '@framework/workbench/ui/align/align-vertically-center/config';
import { config as vBottomConfig } from '@framework/workbench/ui/align/align-vertically-bottom/config';
import { config as hDistributeConfig } from '@framework/workbench/ui/align/align-distribute-horizontallt/config';
import { config as vDistributeConfig } from '@framework/workbench/ui/align/align-distribute-vertically/config';
import {
    ALIGN_DISTRIBUTE_HORIZONTAL_ICON,
    ALIGN_DISTRIBUTE_VERTICAL_ICON,
    ALIGN_VERTICAL_TOP_ICON,
    ALIGN_VERTICAL_CENTER_ICON,
    ALIGN_VERTICAL_BOTTOM_ICON,
    ALIGN_HORIZONTAL_LEFT_ICON,
    ALIGN_HORIZONTAL_CENTER_ICON,
    ALIGN_HORIZONTAL_RIGHT_ICON,
} from '@src/framework/workbench/drawer/image';
import Style from '@framework/workbench/drawer/ui/index.less';
import { COMMON_STYLE } from '@framework/workbench/drawer/common/config';

export const FORM_CONFIGS_H_LEFT: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: hLeftConfig.id,
        options: {
            icon: <img src={ALIGN_HORIZONTAL_LEFT_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: hLeftConfig.content,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_H_CENTER: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: hCenterConfig.id,
        options: {
            icon: <img src={ALIGN_HORIZONTAL_CENTER_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: hCenterConfig.content,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_H_RIGHT: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: hRightConfig.id,
        options: {
            icon: <img src={ALIGN_HORIZONTAL_RIGHT_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: hRightConfig.content,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_V_TOP: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: vTopConfig.id,
        options: {
            icon: <img src={ALIGN_VERTICAL_TOP_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: vTopConfig.content,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_V_CENTER: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: vCenterConfig.id,
        options: {
            icon: <img src={ALIGN_VERTICAL_CENTER_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: vCenterConfig.content,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_V_BOTTOM: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: vBottomConfig.id,
        options: {
            icon: <img src={ALIGN_VERTICAL_BOTTOM_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: vBottomConfig.content,
        style: COMMON_STYLE,
    },
];

const DISTRIBUTE_STYLE: CSSProperties = {
    ... COMMON_STYLE,
    minWidth: 116,
};

export const FORM_CONFIGS_H_DISTRIBUTE: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: hDistributeConfig.id,
        options: {
            icon: <img src={ALIGN_DISTRIBUTE_HORIZONTAL_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: DISTRIBUTE_STYLE,
        tooltip: hDistributeConfig.content,
    },
];

export const FORM_CONFIGS_V_DISTRIBUTE: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: vDistributeConfig.id,
        options: {
            icon: <img src={ALIGN_DISTRIBUTE_VERTICAL_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: DISTRIBUTE_STYLE,
        tooltip: vDistributeConfig.content,
    },
];
